<nav class="navbar shadow navbar-expand-md navbar-light bg-white" style="margin-top: 25px;">
  <div class="container-fluid align-items-center">
    <!-- <div class="col-2" style="visibility: hidden;">
      <img (click)="toggleLanguage();close()" class="img-fluid changelang" src="/assets/changeLanguage.png"
        alt="change language button image" />
    </div> -->

    @if (tokenExists) {
    <a class="col-8" style="text-align: right;margin-top: 15px;" routerLink="/Home.mobile">
      <img src="/assets/logo-mobile.png" style="width: 200px;" />
    </a>
    <button class="navbar-toggler mobile-menu-btn" style="padding: 0;" type="button" data-bs-toggle="collapse"
      data-bs-target="#navbarNav" aria-controls="navbarNav" (click)="openMenuToggle()" aria-expanded="false"
      aria-label="Toggle navigation">
      <i class="fa-solid fa-bars"></i>
    </button>
    }
    @else{
    <a class="col-12" style="text-align: center;" routerLink="/Home.mobile">
      <img src="/assets/logo-mobile.png" style="width: 200px;" />
    </a>
    }
  </div>
</nav>
<div *ngIf="openMenu" class="popup">
  <div class="maindev">
    <button (click)='close()' class="close btn btn-primary "> {{ "close" | translate }} </button>
    <div class="mobile-menu">
      <ul class="navbar-nav ms-auto col-12 col-md-6 justify-content-end">
        @if(isEmployee) {

        <li class="nav-item" (click)='close()' routerLink="/fingerprint">
          <img routerLink="/fingerprint" class="imagessize" src="/assets/fingerprint.png" alt="fingerprint" />
          <a class="text-decoration-none nav-link" routerLink="/fingerprint" routerLinkActive="active">{{
            'fingerprint' | translate }}</a>
        </li>
        <li class="nav-item" (click)='close()' routerLink="/Profile">
          <img class="imagessize" src="/assets/profile.png" alt="profile" routerLink="/Profile" />
          <a class="text-decoration-none nav-link" routerLink="/Profile" routerLinkActive="active">{{ "Profile" |
            translate }}</a>
        </li>
        }
        @else if(isfinancialEmployee) {
        <li class="nav-item" (click)='close()' routerLink="/dailyexpenses">
          <img routerLink="/dailyexpenses" class="imagessize" src="/assets/card photo.png" alt="profile" />
          <a class="text-decoration-none nav-link" routerLink="/dailyexpenses" routerLinkActive="active">{{
            "financial" |
            translate }}</a>
        </li>
        <li class="nav-item" (click)='close()' routerLink="/fingerprint">
          <img routerLink="/fingerprint" class="imagessize" src="/assets/fingerprint.png" alt="fingerprint" />
          <a class="text-decoration-none nav-link" routerLink="/fingerprint" routerLinkActive="active">{{
            'fingerprint' | translate }}</a>
        </li>
        <li class="nav-item" (click)='close()' routerLink="/Profile">
          <img class="imagessize" src="/assets/profile.png" alt="profile" routerLink="/Profile" />
          <a class="text-decoration-none nav-link" routerLink="/Profile" routerLinkActive="active">{{ "Profile" |
            translate }}</a>
        </li>
        }
        @else{
        <ng-container>

          <li class="nav-item" (click)='close()' routerLink="/companies">
            <img routerLink="/companies" class="imagessize" src="/assets/Home.png" alt="companies" />
            <a class="text-decoration-none nav-link" routerLink="/companies" routerLinkActive="active">
              الشركات</a>
          </li>
          <li class="nav-item" (click)='close()' routerLink="/doctors">
            <img routerLink="/doctors" class="imagessize" src="/assets/all users.png" alt="doctors" />
            <a class="text-decoration-none nav-link" routerLink="/doctors" routerLinkActive="active">
              الاطباء</a>
          </li>
          <li class="nav-item" (click)='close()' routerLink="/alljobs">
            <img routerLink="/alljobs" class="imagessize" src="/assets/all users.png" alt="alljobs" />
            <a class="text-decoration-none nav-link" routerLink="/alljobs" routerLinkActive="active">
              الكوادر</a>
          </li>
          <li class="nav-item" (click)='close()' routerLink="/dataflow">
            <img routerLink="/dataflow" class="imagessize" src="/assets/vvv.png" alt="dataflow" />
            <a class="text-decoration-none nav-link" routerLink="/dataflow" routerLinkActive="active">
              داتافلو</a>
          </li>
          <li class="nav-item" (click)='close()' routerLink="/flyclients">
            <img routerLink="/flyclients" class="imagessize" src="/assets/collect.png" alt="flyclients" />
            <a class="text-decoration-none nav-link" routerLink="/flyclients" routerLinkActive="active">
              الطيران</a>
          </li>

          <li class="nav-item" (click)='close()' routerLink="/complex">
            <img routerLink="/complex" class="imagessize" src="/assets/phone1.png" alt="complex" />
            <a class="text-decoration-none nav-link" routerLink="/complex" routerLinkActive="active">
              طلبيات</a>
          </li>
          <li class="nav-item" (click)='close()' routerLink="/myclients">
            <img routerLink="/myclients" class="imagessize" src="/assets/phone.png" alt="myclients" />
            <a class="text-decoration-none nav-link" routerLink="/myclients" routerLinkActive="active">
              {{ "myclients" |
              translate }}</a>
          </li>
          @if (isAdmin) {
            <li class="nav-item" (click)='close()' routerLink="/employeepage.mobile">
              <img routerLink="/employeepage.mobile" class="imagessize" src="/assets/emploees.png"
                alt="emploees" />
              <a class="text-decoration-none nav-link" routerLink="/employeepage.mobile" routerLinkActive="active">{{
                'employees' | translate }}</a>
            </li>
          }
          <li class="nav-item" (click)='close()' routerLink="/fingerprint">
            <img routerLink="/fingerprint" class="imagessize" src="/assets/fingerprint.png" alt="fingerprint" />
            <a class="text-decoration-none nav-link" routerLink="/fingerprint" routerLinkActive="active">{{
              'fingerprint' | translate }}</a>
          </li>

          @if (isAdmin) {
            <li class="nav-item" (click)='close()' routerLink="/allusers.mobile">
              <img routerLink="/allusers.mobile" class="imagessize" src="/assets/profile.png" alt="profile" />
              <a class="text-decoration-none nav-link" routerLink="/allusers.mobile" routerLinkActive="active">{{ "Users"
                | translate }}</a>
            </li>
          }


        </ng-container>
        }
        @if (tokenExists) {
        <li class="nav-item" (click)="logout()">
          <img src="/assets/log out 1.png" alt="" class="imagessize" />
          <a class="text-decoration-none nav-link">{{ "Log out" | translate }}</a>
        </li>
        }
      </ul>
    </div>
  </div>
</div>
